module.exports = __webpack_public_path__ + "static/img/ranking_coin_3.84fc841.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_coin_3.png
// module id = Y3y9
// module chunks = 0